import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {LabelRequestModel} from '../models/labels/label-request.model';
import {LabelResponseModel} from '../models/labels/label-response.model';
import {
    cfgFormattedLabelModel,
    cfgFormattedLabelTokenModel,
    cfgLetterTokens,
    FormattedLabelUserModel,
    LabelTokenModel
} from '../models/labels/formattedLabelUser.model';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LabelService {

    constructor(private readonly http: HttpClient) {

    }

    getOrganizerLabels(model: LabelRequestModel) {
        return this.http.post<LabelResponseModel[]>('api/labels/organizer', model);
    }

    getFormattedLabelUsers() {
        return this.http.get<FormattedLabelUserModel[]>('api/label/getFormattedLabelUsers');
    }

    getLetterTokenLabelsLabelUsers() {
        return this.http.get<cfgLetterTokens[]>('api/label/getLetterTokensForLabel');
    }

    getFormattedLabelsByUserId(FormattedLabelUserID: string) {
        return this.http.get<cfgFormattedLabelTokenModel[]>(`api/label/getFormattedLabelsByUserId/${FormattedLabelUserID}`);
    }

    createFormattedLabelUsers(UserID: string) {
        return this.http.get<FormattedLabelUserModel>(`api/label/createFormattedLabelUsers/${UserID}`);
    }


    getLabelTokensByFormattedLabel(formattedLabelId: string, PatientId: string, PatientCaseId : string, DocumentId: string, AppointmentId: any = null): Observable<LabelTokenModel[]> {
        return this.http.get<LabelTokenModel[]>(`api/label/getLabelTokensByFormattedLabel/${formattedLabelId}/${PatientId}/${PatientCaseId}/${DocumentId}/${AppointmentId}`);
    }


    deleteFormattedLabelToken(formattedLabelTokenId: string): Observable<cfgFormattedLabelTokenModel> {
        return this.http.get<cfgFormattedLabelTokenModel>(`api/label/deleteFormattedLabelToken/${formattedLabelTokenId}`);
    }

    saveFormattedLabelToken(formattedLabelToken: cfgFormattedLabelTokenModel): Observable<cfgFormattedLabelTokenModel> {
        return this.http.post<cfgFormattedLabelTokenModel>('api/label/saveFormattedLabelToken', formattedLabelToken);
    }

    saveFormattedLabel(newFormattedLabel: cfgFormattedLabelModel): Observable<cfgFormattedLabelModel> {
        return this.http.post<cfgFormattedLabelModel>('api/label/saveFormattedLabel', newFormattedLabel);
    }


}
